
export const environment = {
    production: true,
    googlePlacesApiKey: 'AIzaSyDW_RhNMchTilWj6McY8VEAH-DjZ4do6s8'
};
